import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {AppearingContainer} from "./AppearingContainer";
import {Howl} from "howler";

// Constructor
export class AppearingInteractiveButton extends AppearingContainer {

  constructor(callback, appearingScreenPercent, game, clickSound) {
    super(appearingScreenPercent, game);

    this.originalPosition = {x: 0, y: 0};
    this.callback = callback;

    // Click sound
    if (clickSound) {
      this.clickSound = new Howl({
        src: [clickSound],
        loop: false,
        autoplay: false,
      });
    }

  }

  enable() {
    this.eventMode = "static";
    this.removeAllEvents();

    this.on("pointerdown", this.onPress, this);
  }

  disable() {
    this.eventMode = "none";
    this.removeAllEvents();
  }

  //
  buildAnimations() {

    this.inAnimation = gsap.fromTo(this,
      {
        pixi: {
          scale: 0
        }
      },
      {
        pixi: {
          scale: 1
        },
        ease: "back.out(1.7)",
        immediateRender: true, // makes the circle scale 0 immediately, even if tween is paused
        paused: true,
        duration: 0.5,
        overwrite: "auto",
        onComplete: () => {
          this.enable();
        }
      }
    )
  }

  onPress(e) {
    // The button should be already offset from the parent so we can scale from the center
    gsap.to(this, {
      pixi: {
        scale: 0.95
      },
      duration: 0.15,
      overwrite: "auto"
    });

    if(this.clickSound) {
      this.clickSound.play();
    }

    this.off("pointerdown", this.onPress, this);
    this.on("pointerup", this.onRelease, this);
    this.on("pointerupoutside", this.onRelease, this);
  }

  // Animate back and execute action
  onRelease() {
    gsap.to(this, {
      pixi: {
        scale: 1
      },
      ease: "back.out(4)",
      duration: 0.15,
      overwrite: "auto",
      onComplete: () => {
        this.on("pointerdown", this.onPress, this);
      }
    });

    if(this.clickSound) {
      this.clickSound.stop();
    }

    this.off("pointerup", this.onRelease, this);
    this.off("pointerupoutside", this.onRelease, this);

    this.callback();
  }

  removeAllEvents() {
    this.off("pointerdown", this.onPress, this);
    this.off("pointerup", this.onRelease, this);
    this.off("pointerupoutside", this.onRelease, this);
  }

}
